import React from 'react';
import cx from 'classnames';
import './Heading.css';

const Heading = ({ size = "default", children}) => {

    // define classes
    const classes = cx(
        `heading`,
        `size-${size}`
    );

    // render html
    return(
        <div className={classes}>
            {children}
        </div>
    );
}

export default Heading;